import {
  DefaultRuleNames,
  IndustryVerticals,
  OrgFeature,
  ConsortiumType,
} from 'app/modules/orgManagement/models';

export interface ShortOrgResponse {
  created_at: string | null;
  default_unit: string;
  display_name: string;
  id: number;
  is_parent: boolean;
  name: string;
  parent_id: number | null;
}

export interface ChainalysisKYTConfig {
  enabled: boolean;
  always_create_alert: boolean;
  only_flagged_alerts: boolean;
  inherit_entity_tags: boolean;
  include_behavioral_alerts: boolean;
  include_withdrawal_alerts: boolean;
  polling_parameter?: ChainalysisPollingParameter;
}

export enum ChainalysisPollingParameter {
  ALERT_STATUS_CREATED_AT = 'alertStatusCreatedAt',
  CREATED_AT = 'createdAt',
  DISPOSITION_DATE = 'dispositionDate',
  STATUS_CHANGED_AT = 'statusChangedAt',
  VALIDITY_UPDATED_AT = 'validityUpdatedAt',
}

export interface ConsortiumConfigResponse {
  enabled?: boolean;
  backfilled?: boolean;
  backfill_task_uuid?: string;
}

export enum LoginMode {
  AUTH0 = 'auth0',
  GOOGLE_OAUTH2 = 'google-oauth2',
  PINGFEDERATE = 'pingfederate',
  SAMLP = 'samlp',
}

export enum RealTimeRulesStatusOptions {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export interface RealTimeRulesConfig {
  status: RealTimeRulesStatusOptions;
  subtype_limit?: number;
}

export interface RuleExecutionConfig {
  watchlist_entity_screening_limit?: number; // Deprecated: use unique_entity_screening_limit
  unique_entity_screening_limit?: number;
  share_entity_screening_enabled?: boolean;
}

export interface CTRGenerationConfig {
  timezone?: string;
  observed_holidays?: string[];
  business_hours_end?: string;
}

export interface AIAgentConfig {
  alert_review_limit_monthly: number | undefined;
}

export interface FullOrgResponse {
  real_time_rules_config: RealTimeRulesConfig;
  consortium_config?: ConsortiumConfigResponse;
  created_at: string | null;
  default_unit: string;
  display_name: string;
  id: number;
  is_parent: boolean;
  kyt_config?: { chainalysis?: ChainalysisKYTConfig };
  login_modes: LoginMode[];
  name: string;
  org_features: OrgFeature[];
  org_features_failed?: OrgFeature[];
  parent_id: number | null;
  rule_execution_config?: RuleExecutionConfig;
  ctr_generation_config?: CTRGenerationConfig;
  consortium_type?: ConsortiumType;
  ai_agent_config?: AIAgentConfig;
}

export interface DefaultRule {
  title: string;
  description: string;
  identifier: DefaultRuleNames;
  industry_vertical_list: IndustryVerticals[];
}

export interface EnrichmentConfig {
  fingerprint?: {
    enabled: boolean;
    version: string;
  };
  trm?: {
    enabled: boolean;
    version: string;
  };
}

export interface AdminOrgSettingsResponse {
  createdAt: string;
  updatedAt: string;
  orgId: number;
  features: string;
  lumosConfig: string;
  queryBuilderConfig: string;
  storageConfig: string;
  sarConfig: string;
  homeCurrencyCode: string;
  currencyConfig: string;
  scenarioConfig: string;
  alertConfig: string;
  orgEnums: string;
  orgEnumsConfig: string;
  ruleExecutionConfig: string;
  tagLimit: string;
  linkAnalysisConfig: string;
  ruleRelevanceMetricConfig: string;
  dataConfig: string;
  kytConfig: string;
  unit21IdConfig: string;
  webhookConfig: string;
  ffipPgpEncryptionEnabled: boolean;
  enrichmentConfig: EnrichmentConfig;
  displayTimezone: string | null;
}

export interface GetOrgChildrenResponse {
  children: { id: number; name: string }[];
}

export interface OrgAgent {
  id: number;
  org_id: number;
  full_name: string;
  email: string;
  org_switcher_orgs: string[] | null;
}

export interface GetOrgAgentsResponse {
  parent_agents: OrgAgent[];
  count: number;
}

export interface FingerprintKeysResponse {
  public_key: string;
  created_at: string;
  active: boolean;
}

export interface TrmKeysResponse {
  id: number;
  api_key_masked: string;
  created_at: string;
  deactivated_at: string | null;
}
